import React from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pTradeSellComplete.css';

const mockOrderData = {
  orderId: '9573006193730401',
  buyer: {
    name: 'Ubong Ben',
    initial: 'U',
    verified: true,
    fullName: 'UBONG BEN'
  },
  orderDetails: {
    quantity: '10.00',
    crypto: 'USDT',
    amountFiat: '615.00',
    currency: 'PHP',
    price: '61.5',
    priceUnit: 'PHP/USDT'
  },
  paymentMethod: {
    bankName: 'GCASH',
    accountName: 'Myrna Luz Tan',
    bank: 'GCASH',
    accountNumber: '09178389080',
    icon: 'G'
  }
};

const P2pTradeSellComplete: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleChat = () => {
    console.log('Opening chat...');
  };

  const handleCopyOrderId = () => {
    navigator.clipboard.writeText(mockOrderData.orderId);
  };

  const handleCopyAccountName = () => {
    navigator.clipboard.writeText(mockOrderData.paymentMethod.accountName);
  };

  const handleCopyAccountNumber = () => {
    navigator.clipboard.writeText(mockOrderData.paymentMethod.accountNumber);
  };

  const handleBackToP2P = () => {
    navigate('/');
  };

  return (
    <div className="sell-complete-container">
      <div className="sell-complete-success-banner">
        <div className="sell-complete-success-content">
          <span className="sell-complete-success-title">Success!</span>
          <span className="sell-complete-success-subtitle">Crypto Released for P2P Trade</span>
        </div>
      </div>

      <header className="sell-complete-header">
        <div className="sell-complete-header-left">
          <button className="sell-complete-back-button" onClick={handleBack} aria-label="Go back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="sell-complete-title">Buy USDT</h1>
        </div>

        <button className="sell-complete-chat-button" onClick={handleChat} aria-label="Chat">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17 8.5C17 12.366 13.866 15.5 10 15.5C8.95 15.5 7.951 15.28 7.049 14.888L3 16L4.112 11.951C3.72 11.049 3.5 10.05 3.5 9C3.5 5.134 6.634 2 10.5 2C14.366 2 17.5 5.134 17.5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </header>

      <div className="sell-complete-progress-container">
        <div className="sell-complete-progress-bar">
          <div className="sell-complete-progress-fill" style={{ width: '100%' }} />
        </div>
      </div>

      <div className="sell-complete-content">
        <div className="sell-complete-status-card">
          <div className="sell-complete-status-blur-top" />
          <div className="sell-complete-status-blur-bottom" />
          
          <div className="sell-complete-status-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="#22c35d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className="sell-complete-status-text">
            <h2 className="sell-complete-status-heading">Trade Completed</h2>
            <p className="sell-complete-status-subheading">Successfully Concluded</p>
          </div>

          <p className="sell-complete-status-message">
            This trade has been successfully concluded
          </p>
        </div>

        <div className="sell-complete-merchant-card">
          <div className="sell-complete-merchant-avatar">
            {mockOrderData.buyer.initial}
          </div>
          
          <div className="sell-complete-merchant-info">
            <div className="sell-complete-merchant-name">
              {mockOrderData.buyer.name}
              {mockOrderData.buyer.verified && (
                <svg className="sell-complete-verified-badge" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 0L11.5 6.5L18 8L11.5 9.5L10 16L8.5 9.5L2 8L8.5 6.5L10 0Z" fill="#22c35d"/>
                </svg>
              )}
            </div>
            <div className="sell-complete-merchant-label">Merchant</div>
          </div>
        </div>

        <div className="sell-complete-order-id-card">
          <div className="sell-complete-order-id-label">ID</div>
          <div className="sell-complete-order-id-value">{mockOrderData.orderId}</div>
          <button 
            className="sell-complete-copy-button" 
            onClick={handleCopyOrderId}
            aria-label="Copy order ID"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="sell-complete-details-card">
          <div className="sell-complete-detail-box sell-complete-detail-crypto-box">
            <span className="sell-complete-detail-label">Quantity</span>
            <div className="sell-complete-detail-value-group">
              <span className="sell-complete-detail-amount">{mockOrderData.orderDetails.quantity}</span>
              <span className="sell-complete-detail-crypto">{mockOrderData.orderDetails.crypto}</span>
            </div>
          </div>

          <div className="sell-complete-detail-box sell-complete-detail-fiat-box">
            <span className="sell-complete-detail-label">Amount (Fiat)</span>
            <div className="sell-complete-detail-value-group">
              <span className="sell-complete-detail-amount">{mockOrderData.orderDetails.amountFiat}</span>
              <span className="sell-complete-detail-currency">{mockOrderData.orderDetails.currency}</span>
            </div>
          </div>

          <div className="sell-complete-detail-box sell-complete-detail-price-box">
            <span className="sell-complete-detail-label">Price</span>
            <div className="sell-complete-detail-value-group">
              <span className="sell-complete-detail-amount">{mockOrderData.orderDetails.price}</span>
              <span className="sell-complete-detail-unit">{mockOrderData.orderDetails.priceUnit}</span>
            </div>
          </div>
        </div>

        <div className="sell-complete-payment-card">
          <div className="sell-complete-payment-merchant">
            <span className="sell-complete-payment-label">Merchant Name</span>
            <span className="sell-complete-payment-value">{mockOrderData.buyer.fullName}</span>
          </div>

          <div className="sell-complete-bank-header">
            <div className="sell-complete-bank-icon">
              {mockOrderData.paymentMethod.icon}
            </div>
            <span className="sell-complete-bank-name">{mockOrderData.paymentMethod.bankName}</span>
            <div className="sell-complete-bank-badge" />
          </div>

          <div className="sell-complete-payment-info">
            <div className="sell-complete-payment-info-box">
              <span className="sell-complete-payment-info-label">Account Name</span>
              <span className="sell-complete-payment-info-value">{mockOrderData.paymentMethod.accountName}</span>
              <button 
                className="sell-complete-copy-icon-button" 
                onClick={handleCopyAccountName}
                aria-label="Copy account name"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>

            <div className="sell-complete-payment-info-box">
              <span className="sell-complete-payment-info-label">Bank</span>
              <span className="sell-complete-payment-info-value">{mockOrderData.paymentMethod.bank}</span>
            </div>

            <div className="sell-complete-payment-info-box">
              <span className="sell-complete-payment-info-label">Account Number</span>
              <span className="sell-complete-payment-info-value sell-complete-account-number">{mockOrderData.paymentMethod.accountNumber}</span>
              <button 
                className="sell-complete-copy-icon-button" 
                onClick={handleCopyAccountNumber}
                aria-label="Copy account number"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <rect x="5" y="5" width="9" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M3 11V3C3 2.44772 3.44772 2 4 2H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <button className="sell-complete-back-p2p-button" onClick={handleBackToP2P}>
          Back to P2P Trading
        </button>
      </div>
    </div>
  );
};

export default P2pTradeSellComplete;